import esenScreen from "images/esen-screenshot.jpg"
import esenScreenSmall from "images/esen-screenshot-small.jpg"
import esenHero from "images/esen_hero.jpg"
import l2eScreen from "images/l2e-screenshot.png"
import l2eScreenSmall from "images/l2e-screenshot-small.png"
import esportStage from "images/esport-stage.jpg"
import esportStageCropped from "images/esport-stage-crop.jpg"
import timImage from "images/tim.png"
import rolfImage from "images/rolf-engman.png"
import miasanoHero from "images/miasano-hero.jpg"
import miasanoHeroSmall from "images/miasano-hero-small.jpg"
import miasanoScreen from "images/miasano-menu.png"
import saitsLogo from "images/saits-logo-text.png"
import l2eLogo from "images/l2elogo-white.png"
import esenLogo from "images/esen-logo.png"
import esenMonitor from "images/esen_secondary.jpg"
import l2eMiddleImage from "images/l2e-middle-image.png"

const defaults = {
  availablePositions: [
    {
      __typename: "AvailablePosition",
      title: "Front end-utvecklare",
      path: "/vacancies/front-end-developer",
      description:
        "Vi söker just nu efter en driven front end-utvecklare till vårt team i Uppsala. Vi söker någon som brinner för programmering och som har en vilja att bli bäst tillsammans med oss!",
    },
    {
      __typename: "AvailablePosition",
      title: "Back end-utvecklare",
      path: "/vacancies/back-end-developer",
      description:
        "Vi söker just nu efter en driven back end-utvecklare till vårt team i Uppsala. Vi söker någon som brinner för programmering och som har en vilja att bli bäst tillsammans med oss!",
    },
    {
      __typename: "AvailablePosition",
      title: "Projektledare",
      path: "/vacancies/project-manager",
      description:
        "Vi söker just nu efter en driven projektledare som vill hjälpa oss att utvecklas och växa. Vi vill växa tillsammans med både nya och befintliga kunder och du kommer vara en viktig del av detta.",
    },
  ],
  caseStudies: [
    {
      __typename: "CaseStudy",
      id: 1,
      featuredOnLandingPage: true,
      featuredOnCaseStudiesPage: true,
      company: "ESEN eSports",
      companyType: "Mediastudio med esportinriktning",
      companyLocation: "Stockholm",
      companyLogo: esenLogo,
      replaceLogoWithString: false,
      projectLogo: esenLogo,
      projectGoal:
        "Att lättare kunna styra innehåll kring turneringar och sändningar",
      tools:
        "Ruby on Rails, JavaScript, HTML5, Sass, PostgreSQL, Redis, Elasticsearch",
      websiteString: "kingofnordic.com",
      websiteUrl: "https://kingofnordic.com/",
      landingPageHeroTitle: "Turneringsplattform",
      landingPageHeroImage: esenScreenSmall,
      previewBio:
        "Läs om hur vi utvecklade en <span>turneringsplattform</span> till <span>världens första</span> börsnoterade esport-företag",
      project: "ESEN's turneringsplattform",
      previewBackground: esenHero,
      heroBackground: esenHero,
      caseStudiesPageImage: esenScreen,
      caseStudiesPageImageAltText:
        "Skärmdump från en turnerningsplattform för esport-turneringar som utvecklats av SAITS i Ruby on Rails.",
      imageSectionImage: esenMonitor,
      imageSectionImageAltText:
        "Bildskärm som visar turneringsplattformen då den används för en Counter-Strike: Global Offensive turnering.",
      quote:
        "Arbetet med SAITS har varit otroligt smidigt. De har inte bara levererat en stark teknisk lösning, utan även arbetat proaktivt med designförslag och anpassat sig snabbt efter våra behov. Deras tekniska expertis har varit en trygghet och produkten som utvecklats är en grundbult i ESEN’s framtida tillväxt.",
      quoteImage: timImage,
      quoteAuthor: "Tim Kjell",
      quoteAuthorPosition: "CTO",
      tags: ["Ruby on Rails", "Esport", "UI/UX"],
      title:
        "Turneringsplattform till världens första börsnoterade esport-företag",
      path: "/case-studies/esen",
      primaryColor: "#2f3542",
      secondaryColor: "#ef7f0a",
      metaDescription:
        "”Arbetet med SAITS har varit otroligt smidigt. De har inte bara levererat en stark teknisk lösning, utan även arbetat proaktivt med designförslag och anpassat sig snabbt efter våra behov. Deras tekniska expertis har varit en trygghet och produkten som utvecklats är en grundbult i ESEN’s framtida tillväxt.”",
    },
    {
      __typename: "CaseStudy",
      id: 2,
      featuredOnLandingPage: true,
      featuredOnCaseStudiesPage: true,
      company: "Miasano",
      companyType: "Digital hälsa",
      companyLocation: "Stockholm",
      projectGoal: "Att underlätta för personer med hypertyreos",
      tools: "React Native, JavaScript, HTML5, Sass, PostgreSQL, Ruby on Rails",
      websiteString: null,
      websiteUrl: null,
      landingPageHeroTitle: "Mobilapplikation inom digital hälsa",
      landingPageHeroImage: miasanoHeroSmall,
      replaceLogoWithString: true,
      previewBio:
        "Mobilapplikation som <span>underlättar</span> för personer med hypertyreos",
      project: "Miasano",
      companyLogo: "Miasano",
      projectLogo: "Miasano",
      previewBackground: null,
      heroBackground: miasanoHero,
      caseStudiesPageImage: miasanoScreen,
      caseStudiesPageImageAltText:
        "Skärmdump från en app som underlättar för personer med hypertyreos som utvecklats av SAITS i React Native.",
      imageSectionImage: null,
      imageSectionImageAltText: null,
      quote: null,
      quoteImage: null,
      quoteAuthor: null,
      quoteAuthorPosition: null,
      tags: ["React Native", "Medicin", "Mobilapplikation"],
      title: "Mobilapplikation som underlättar för personer med hypertyreos",
      path: "/case-studies/miasano",
      primaryColor: null,
      secondaryColor: "#34C4B6",
      metaDescription:
        "SAITS hjälpte Miasano att utveckla en mobilapp som underlättar livet för människor med hypertyreos. Med appen kan de på ett enkelt sätt följa sina symptom och medicinintag.",
    },
    {
      __typename: "CaseStudy",
      id: 3,
      featuredOnLandingPage: true,
      featuredOnCaseStudiesPage: true,
      replaceLogoWithString: false,
      company: "Learn2Esport",
      companyType: "Digital produktutvecklingsbyrå",
      companyLocation: "Uppsala",
      projectGoal:
        "Att erbjuda helhetslösningar för skolor som vill driva esportinriktningar",
      tools: "Ruby on Rails, React, JavaScript, HTML5, Sass, PostgreSQL, Redis",
      websiteString: "learn2esport.com",
      websiteUrl: "https://learn2esport.com/",
      landingPageHeroTitle: "Utbildningsplattform",
      landingPageHeroImage: l2eScreenSmall,
      companyLogo: saitsLogo,
      projectLogo: l2eLogo,
      previewBio:
        "Läs om vår <span>utbildningsplattform</span> för skolor som vill starta en <span>esportprofil</span>",
      project: "Learn2Esport",
      previewBackground: esportStageCropped,
      heroBackground: esportStage,
      caseStudiesPageImage: l2eScreen,
      caseStudiesPageImageAltText:
        "Skärmdump från en utbildningsplattform som erbjuder helhetslösningar för skolor som vill driva esportinriktningar.",
      imageSectionImage: l2eMiddleImage,
      imageSectionImageAltText:
        "Slutanvändare som använder Learn2Esport-plattformen.",
      quote:
        "Tittar vi ut i världen så är esport betydligt större sett till tittarsiffror än till exempel Stanley Cup och NBA-finalen. Det är klart att man kan höja på ögonbrynen om en seriös gymnasieskola ägnar sig åt spel, men vi måste också följa med i tiden och göra något kvalitativt och bra av det. Tack vare Learn2Esport så har vi fått hjälp med allt vi behöver. De har besvarat alla våra frågor och tagit fram en lösning som eleverna älskar.",
      quoteImage: rolfImage,
      quoteAuthor: "Rolf Engman",
      quoteAuthorPosition: "Gymnasiechef och Rektor",
      tags: ["Ruby on Rails", "Esport", "Utbildning"],
      title: "Utbildningsplattform för skolor som vill starta en esportprofil",
      path: "/case-studies/learn2esport",
      primaryColor: "#29303f",
      secondaryColor: "#4969BD",
      metaDescription:
        "Learn2Esport är en helhetslösning för skolor som vill starta en esportprofil. Den används just nu på fyra skolor i Sverige. Learn2Esport är vår egen produkt och den centrala delen är den plattform vi utvecklat.",
    },
  ],
}

export default defaults



// WEBPACK FOOTER //
// ./src/state.js